<template>
  <a-spin :spinning="loading">
    <a-row :gutter="[16,16]">
      <a-form-model layout="vertical" :model="profesionNaci" :rules="formRules"
                    @submit="guardarDatosProfesionNacionalidad"
                    @submit.native.prevent ref="profesionNacionalidad">
            <a-col :span="24">
              <a-card>
                <a-row :gutter="[16,16]" :md="12">
                  <a-col v-bind="colSpan">
                    <a-form-model-item :label="$t('Nacionalidad')" prop="id_h_citizenship" has-feedback>
                      <form-model-dropdown style="width: 100%"
                                           v-model="profesionNaci.id_h_citizenship"
                                           endpoint="hierarchy_lookup"
                                           :params="request.id_h_citizenship"
                      ></form-model-dropdown>
                    </a-form-model-item>
                  </a-col>

                  <a-col v-bind="colSpan" v-show="$getConfigValue('BIODATA_MOSTRAR_CAMPO_PROFESION_ODP', 'SI') !== 'NO'">
                    <a-form-model-item :label="$t('Profesion')" prop="id_h_profession" has-feedback>
                      <form-model-lookup style="width: 100%"
                                           v-model="profesionNaci.id_h_profession"
                                           endpoint="hierarchy_lookup"
                                           :params="request.id_h_profession"
                      ></form-model-lookup>
                    </a-form-model-item>
                  </a-col>
                </a-row>
                <template slot="actions" class="ant-card-actions">
                    <a-button v-if="!$userIsInrol('Query')"
                      style="float: right;"
                      type="primary"
                      html-type="submit">
                      Guardar Cambios
                    </a-button>
                </template>
              </a-card>
            </a-col>
      </a-form-model>
    </a-row>
  </a-spin>
</template>
<script>
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'
  import JsUtils from '@/util/JsUtils'
  import HttpUtil from '@/util/HttpUtil'

  export default {
    props: ['persona'],
    mounted () {
      this.httpClient = new HttpUtil()
      this.loadData()
    },

    data () {
      return {
        request: {
          id_h_citizenship: {
            h_lookup_type: 'NACIONALIDAD'
          },
          id_h_profession: {
            h_lookup_type: 'PROFESION'
          }

        },
        profesionNaci: {},
        formRules: {},
        loading: false,
        colSpan: {
          xs: 24,
          md: 12
        }
      }
    },
    methods: {
      initFormRules () {
        // TODO SE DEBE CONSULTAR DESDE LA PARAMETRIZACIÓN BD.
        this.formRules = {
          id_h_citizenship: [{
            required: this.$getConfigValue('BIODATA_REQUERIDO_ID_H_CITIZENSHIP', false) === 'SI',
            message: 'Valor requerido'
          }],
          id_h_profession: [{
            required: this.$getConfigValue('BIODATA_REQUERIDO_ID_H_CITIZENSHIP', false) === 'SI',
            message: 'Valor requerido'
          }]
        }
      },
      guardarDatosProfesionNacionalidad () {
        let request = {...this.profesionNaci, id_person: this.persona}
        if (this.loading) return
        this.$refs.profesionNacionalidad.validate(valid => {
          if (valid) {
            this.loading = true
            this.httpClient.getInstance().post('biodata/guardar_datos_profesion_nacionalidad', request)
              .then(() => {
                Mensajes.success('Correcto', 'Datos guardados correctamente')
              })
              .catch(() => {
                Mensajes.error('Error', 'No fue posible guardar la información, contacte al administrador.')
              })
              .then(() => {
                this.loading = false
              })
          }
        })
      },
      loadData () {
        if (JsUtils.isEmpty(this.persona)) {
          return
        }
        this.loading = true

        this.httpClient.getInstance().get('biodata/consultar_otros_datos_personales/' + this.persona)
          .then(response => {
            if (response.data.length === 0) {
              this.profesionNaci = {}
            } else {
              this.profesionNaci = response.data
            }
          })
          .catch(() => {
            Mensajes.error('Error', 'No fue posible consultar los datos personales, contacte al administrador.')
          })
          .then(() => {
            this.loading = false
          })
      }
    },
    watch: {
      persona () {
        this.loadData()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Biodata/BiodataOtrosDatosPersonales.vue